import { render } from "./GroupCardCover.vue?vue&type=template&id=5b75ad64&scoped=true"
import script from "./GroupCardCover.vue?vue&type=script&lang=js"
export * from "./GroupCardCover.vue?vue&type=script&lang=js"

import "./GroupCardCover.vue?vue&type=style&index=0&id=5b75ad64&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\a\\WebApp\\FAOU.App\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b75ad64"]])

export default __exports__